export const defaultSearchValues = {
  initDate: null,
  endDate: null,
  tipo: null,
};

export const tipos = [
  {
    key: "requisition",
    value: "Requisiciones",
  },
  {
    key: "birthday",
    value: "Cumpleaños",
  },
  {
    key: "contract",
    value: "Contratos",
  },
  {
    key: "maternity",
    value: "Licencia Maternidad",
  },
  {
    key: "refund",
    value: "Recomendaciones",
  },
];
export const headers = {
  initialHeaders: [
    {
      title: "Nombre",
      field: "employeeFullName",
      child: null,
    },
    {
      title: "Mensaje",
      field: "message",
      child: null,
    },
    {
      title: "Fecha de notificación",
      field: "notificationDate",
      child: null,
    },
    {
      title: "Tipo",
      field: "notificationType",
      child: null,
    },
  ],
  otherHeaders: [],
};
